import { render, staticRenderFns } from "./PartList.vue?vue&type=template&id=3c73c850"
import script from "./PartList.vue?vue&type=script&lang=ts"
export * from "./PartList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports